module.exports = __webpack_public_path__ + "static/media/topiwisuda.36794b86.png";